module.exports = __webpack_public_path__ + "static/media/auth0-create-tenant-step3.dcb70428.png";